import styled from 'styled-components';
import AgregatorColor from '@assets/images/colors/agregator_background_color.svg';
import PlatformColor from '@assets/images/colors/platform_background_color.svg'; 
import RoomColor from '@assets/images/colors/room_background_color.svg';
import PammColor from '@assets/images/colors/pamm_background_color.svg'; 

export const AgregatorColorImg = styled(AgregatorColor)`
`;

export const PlatformColorImg  = styled(PlatformColor)`
`;

export const RoomColorImg  = styled(RoomColor)`
`;

export const PammColorImg  = styled(PammColor)`
`;
